import React from "react";
import { InputGroup, DropdownButton, Form, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { switchTitleQueryStringAdvanced } from "../api/filterUrlMaker";
import { searchBarSlice } from "../../../redux/slices/searchBarSlice";
import { AdvancedSearchLink } from "./AutoCompleteSearchBox";
import { _t } from "app/i18n/i18n";

// @deprecated - decommed
export const SearchDropdown = () => {
  console.warn("Deprecation warning - SearchDropdown");
  const dispatch = useDispatch();
  const isTitleOnly = useSelector((state) => state.searchbar.isTitleOnly);
  const handleClick = (isTitleOnly) => {
    dispatch(searchBarSlice.actions.setTitleOnly(isTitleOnly));
    switchTitleQueryStringAdvanced(isTitleOnly);
  };

  return (
    <DropdownButton as={InputGroup.Append} variant="secondary rounded-0-left ml-0 pl-0" title="" alignRight>
      <div className="w-100 pl-3 p-2">
        <Form.Check
          type="radio"
          label={_t("All fields")}
          name="search"
          id="search_0"
          onClick={() => handleClick(0)}
          defaultChecked={!isTitleOnly}
        />
        <Form.Check
          type="radio"
          label={_t("Title only")}
          name="search"
          id="search_1"
          onClick={() => handleClick(1)}
          defaultChecked={isTitleOnly}
        />
        <Dropdown.Divider />
        <AdvancedSearchLink />
        {/* <Form.Check type="radio" label="Title &amp; synopsis" name="search" id="search_2" />
        <Form.Check type="radio" label="Analysts" name="search" id="search_3" />
        <Form.Check type="radio" label="Companies" name="search" id="search_4" /> */}
      </div>
    </DropdownButton>
  );
};
